import { useState } from 'react';
import { numify } from 'numify';
import { useTranslation } from 'react-i18next';
import { MdInfoOutline } from 'react-icons/md';
/////////////////////////////////////////////
import {
	CoinImage,
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/app/shared/components';
import { useCustomSelector } from '@/core/redux/hooks';

export const EarnPerHourSection = () => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region States
	**********************/
	const [isOpen, setIsOpen] = useState<boolean>(false);

	/*********************
	// #region Redux
	**********************/
	const { increment_by_hour } = useCustomSelector((state) => state.counter);

	return (
		<div className="flex flex-col flex-1 pr-4">
			<p>{t('coins.counterPerHour')}</p>

			<div className="flex items-center gap-1 mx-auto">
				<CoinImage classes="w-[14px]" />
				<span className="flex items-center leading-[16px] text-yellow-400 font-bold">
					+{numify(increment_by_hour)}
					<TooltipProvider>
						<Tooltip open={isOpen}>
							<TooltipTrigger>
								<div
									className="rounded-lg p-1 text-yellow-400"
									onClick={() => setIsOpen(!isOpen)}
								>
									<MdInfoOutline />
								</div>
							</TooltipTrigger>

							<TooltipContent>
								<p className="text-xs pb-0">
									{t('coins.tooltipRewardPerHour')}
								</p>
							</TooltipContent>
						</Tooltip>
					</TooltipProvider>
				</span>
			</div>
		</div>
	);
};
